import React from 'react';
import FileBrowserModal from './files/FileBrowserModal';

/**
 * The File Browser. Kept as the MainLayout entry point; the dashboard itself
 * (nav, lists, detail panel, folder pickers) lives in ./files.
 *
 * Props: isOpen, onClose, onAttachFile(fileInfo) -> { status }, dataUserId,
 * ownerUserId, viewingUserLabel, workspaceContext,
 * onOpenConversation(conversationId), and the user-level Atlas preferences
 * for the Library settings page: atlasUserPreferences,
 * atlasUserPreferencesSaving, onUpdateAtlasUserPreferences(patch).
 */
export default function FileLibraryModal(props) {
  return <FileBrowserModal {...props} />;
}
